module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-lo"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "lo-modal-title"
  }, [_vm._v("COPY THÀNH VIÊN")]), _c('span', {
    staticClass: "lo-modal-btn-close material-icons",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "note"
  }, [_vm._v("Chuyển toàn bộ thành viên trong lớp học "), _c('span', [_vm._v(_vm._s(_vm.name) + " ")]), _vm._v("sang các lớp còn lại của PC. Vui lòng chọn các lớp học bạn muốn các thành viên này cũng tham gia:")]), _c('div', {
    staticClass: "reg-content"
  }, [(_vm.classes && _vm.classes.length) ? _c('div', {
    staticClass: "box-class-popup"
  }, _vm._l((_vm.classes), function(item, index) {
    return (item.id > 0 && Number(item.id) !== Number(_vm.id)) ? _c('div', {
      staticClass: "item-class"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _c('div', {
      staticClass: "item-checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "class_popup",
        "id": 'class_popup_' + item.id
      },
      domProps: {
        "value": item.id
      },
      on: {
        "click": function($event) {
          return _vm.onClickChecked(item, $event)
        }
      }
    }), _c('label', {
      attrs: {
        "for": 'class_popup_' + item.id
      }
    })])]) : _vm._e()
  }), 0) : _vm._e()])]), _c('div', {
    staticClass: "modal-footer lo-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-12 text-center popup-button"
  }, [(_vm.lstClassSelected.length > 0) ? _c('button', {
    staticClass: "btn-active btn-popup",
    on: {
      "click": _vm.submitClass
    }
  }, [_vm._v("Lưu")]) : _c('button', {
    staticClass: "btn-active btn-popup no-action"
  }, [_vm._v("Lưu")]), _c('button', {
    staticClass: "btn-popup",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("Huỷ yêu cầu")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f9f6bc5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/popup.vue
// module id = 1555
// module chunks = 0